import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTheme } from "@mui/material/styles";

const AccordionFAQ = ({ items, subheader = null, showExpandAll = true }) => {
  const theme = useTheme();

  // Track which indexes are expanded
  const [expanded, setExpanded] = useState([]);
  const allOpen = expanded.length === items.length;

  const handleToggle = (index) => {
    setExpanded((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index) // collapse
        : [...prev, index] // expand
    );
  };

  const handleExpandAll = () => {
    if (allOpen) {
      setExpanded([]); // collapse all
    } else {
      setExpanded(items.map((_, i) => i)); // expand all
    }
  };

  return (
    <Box sx={{ mt: 4 }}>
      {/* Optional subheader + expand button row */}
      {(subheader || showExpandAll) && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          {/* Left: subheader (if provided) */}
          <Box>{subheader}</Box>

          {/* Right: Expand/Collapse button (if enabled) */}
          {showExpandAll && (
            <Button
              variant="outlined"
              size="small"
              onClick={handleExpandAll}
            >
              {allOpen ? "Collapse All" : "Expand All"}
            </Button>
          )}
        </Box>
      )}

      {items.map((item, index) => (
        <Accordion
          key={index}
          expanded={expanded.includes(index)}
          onChange={() => handleToggle(index)}
          sx={{
            bgcolor: theme.palette.background.guideCard,
            borderRadius: 2,
            boxShadow: 1,
            mb: 1.5,
            "&::before": { display: "none" },
          }}
        >
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon sx={{ color: theme.palette.accent.main }} />
            }
            sx={{
              "& .MuiAccordionSummary-content": {
                my: 1,
              },
            }}
          >
            <Typography
              fontWeight={300}
              sx={{
                fontFamily: "'Raleway-ExtraBold', sans-serif",
                fontSize: "1.1rem",
              }}
            >
              {item.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>{item.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default AccordionFAQ;